var exports = {
  "kL": "x43aef4ae--4bbb1e--container",
  "Qs": "x43aef4ae--4bbb1e--content",
  "Ob": "x43aef4ae--4bbb1e--main-text-container",
  "DD": "x43aef4ae--4bbb1e--title",
};

module.exports = exports;
